<template>
	<div class="mainLayout">
		<section class="addRutto">
			<div class="inputBase">
				<p>Inserisci qui l'url youtube del video che vuoi condividere con la comunita</p>
				<div class="inserisciUrl-cont">
					<i class="gdr-icon gdr-icon-youtube-play"></i>
					<input type="url" v-model="newUrl" pattern="^(https://www.youtube.com/)" class="inserisciUrl" />
				</div>
			</div>
			<div class="addVideoAnteprimaVideo" style="max-width:450px;" v-if="youtubeVideoID">
				<p>vuoi aggiungere questo video?</p>
				<videoplayer :videoID="youtubeVideoID" previewType="video" :vote="false" :shadow="false"></videoplayer>
				<div class="buttonAddTo-cont">
					<button @click="addToCommunity" class="buttonAddTo">Aggiungi alla lista</button>
				</div>
			</div>
		</section>
	</div>
</template>
<script>
	var checkIfUrlCorrect = function(url){
		var startingString = "https://www.youtube.com/watch?v="
		if(url.substring(0, startingString.length) == startingString){
			return startingString;
		}else{
			console.log(url.substring(0, startingString.length))
		}

		var embedstarting = "https://youtu.be/"
		if(url.substring(0, embedstarting.length) == embedstarting){
			return embedstarting;
		}else{
			console.log(url.substring(0, embedstarting.length))
		}

		return false;
	}

	var getVideoID = function(url){
		if(checkIfUrlCorrect(url)){
			var baseID = url.replace(checkIfUrlCorrect(url),"");
			var baseIDArray = baseID.split(/(&|\?)/);
			var result = baseIDArray[0];
			return url.replace(checkIfUrlCorrect(url),"");
			
		}
		return false;
	}

	
	const getDataFromUrl = ()=>{
		try{
			var urlObj = new URL(window.location.href);
			var urlData = urlObj.searchParams.get("url") || urlObj.searchParams.get("text") || "";
			return urlData
		} catch (e) {
			return "";
		}
	}

	const removeParamsFromUrl = ()=>{
		const newUrl = new URL(window.location.href);
		if(newUrl.search){
			newUrl.search = "";
			return newUrl
		}
		return false;
	}

	export default {
		name: 'listLayout',
		data () {
			return {
				newUrl: "",
			}
		},
		computed:{
			newUrlCorrect: function(){
				if(checkIfUrlCorrect(this.newUrl)){
					return this.newUrl;
				}
			},
			youtubeVideoID: function(){
				return getVideoID(this.newUrl);
			}
		},
		components:{
			videoplayer: () => import('./videoPlayer')
		},
		methods:{
			addToCommunity: function(){
				this.$root.addVideo(this.newUrl);
				this.newUrl = "";
				const newUrlToGoTo = removeParamsFromUrl();
				if(!newUrlToGoTo){
					this.$router.push('/ruttirecenti');
				} else {
					newUrlToGoTo.search = "";
					newUrlToGoTo.hash = "#/ruttirecenti"
					window.location.href = newUrlToGoTo.href;
				}
			}
		},
		beforeDestroy: function(){
			if((this.$root)&&(this.$root.closeMenu)){
				this.$root.closeMenu()
			}
		},
		mounted: function(){
			const urlFromRoute = getDataFromUrl();
			this.newUrl = urlFromRoute;
		}
	}
</script>
<style lang="less">
	.addRutto{
		text-align: left;
		
		.inputBase{
			max-width:450px; 
			margin:auto;
			margin-bottom:16px;
			background-color:white;
			box-shadow: 0 3px 15px rgba(0,0,0,.31);
			padding:25px;
			.inserisciUrl-cont{
				position: relative;
				.gdr-icon{
					position: absolute;
					line-height: 32px;
					width:32px;
					text-align: center;
					top:0;
					left:0;
					color: #cc181e !important;
				}
			}
			.inserisciUrl{
				display: block;
				line-height: 32px;
				height:32px;
				width:100%;
				box-sizing:border-box;
				padding-left:32px;
				padding-right:10px;
			}
		}
		.addVideoAnteprimaVideo{
			background-color:white;
			box-shadow: 0 3px 15px rgba(0,0,0,.31);
			padding:25px;
			margin-bottom: 150px;
			margin-left: auto;
			margin-right: auto;
			p{
				padding-top:0;
				margin-top: 0;
			}
			.buttonAddTo-cont{
				text-align:right;
				.buttonAddTo{
					background-color: #cc181e;
					color:white;
					border: none !important;
					line-height: 32px;
					padding-left: 10px;
					padding-right: 10px;
					cursor: pointer;
					box-shadow: 0 3px 15px rgba(0,0,0,.60);
					&:hover{
						transform: scale(1.05);
					}
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// addRutto.vue?11379eb7